import { Link, useLocation } from 'react-router-dom';
import { Grid } from 'antd';
import {
  HomeOutlined,
  HomeFilled,
  AppstoreOutlined,
  AppstoreFilled,
  FileTextOutlined,
  ShopOutlined,
  ShopFilled,
} from '@ant-design/icons';
import { useAuth } from '@core/hooks/useAuth';
import { useCopy } from '@/app/providers/useCopy';

export default function MobileTabBarPet() {
  const t = useCopy();
  const { isAuthenticated } = useAuth();
  const screens = Grid.useBreakpoint();
  const hasResolvedBreakpoint = Object.keys(screens).length > 0;
  const isMobile = hasResolvedBreakpoint && !screens.md;
  const { pathname } = useLocation();

  if (!isMobile) return null;

  const handleTabClick = (e, tab) => {
    if (tab.to === '/orders' && !isAuthenticated) {
      e.preventDefault();
      window.dispatchEvent(
        new CustomEvent('open-auth-modal', {
          detail: { mode: 'login', redirect: '/orders' },
        }),
      );
    }
  };

  const tabs = [
    { to: '/', label: t('home', 'Home'), icon: <HomeOutlined />, activeIcon: <HomeFilled /> },
    {
      to: '/categories',
      label: t('allCategoriesPlural', 'Categories'),
      icon: <AppstoreOutlined />,
      activeIcon: <AppstoreFilled />,
    },
    {
      to: '/catalog',
      label: t('catalog', 'Catalog'),
      icon: <ShopOutlined />,
      activeIcon: <ShopFilled />,
    },
    {
      to: '/orders',
      label: t('myOrders', 'My Orders'),
      icon: <FileTextOutlined />,
      activeIcon: <FileTextOutlined />,
    },
  ];

  return (
    <nav className="pet-mobile-tabs" aria-label="Primary">
      {tabs.map((tab) => {
        const isActive = tab.to === '/' ? pathname === '/' : pathname.startsWith(tab.to);
        return (
          <Link
            key={tab.to}
            to={tab.to}
            onClick={(e) => handleTabClick(e, tab)}
            className={isActive ? 'pet-mobile-tab is-active' : 'pet-mobile-tab'}
          >
            <span className="pet-mobile-tab-icon">
              {isActive ? tab.activeIcon : tab.icon}
              {tab.badge > 0 ? <span className="pet-mobile-tab-badge">{tab.badge}</span> : null}
            </span>
            <span className="pet-mobile-tab-label">{tab.label}</span>
          </Link>
        );
      })}
    </nav>
  );
}
